"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Kia = function Kia(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.258 8.935l-.03.027v.305l.03.028h.194c.072 0 .127.055.127.126v5.503c0 .07.055.126.122.126h1.4a.125.125 0 0 0 .126-.126V12.61c0-.056.03-.084.068-.084.054 0 .08.042.096.07l1.653 2.315c.055.083.152.139.219.139h1.665c.068 0 .16-.09.084-.195l-2.107-2.98-.026-.07.026-.082 1.762-2.608c.046-.076-.013-.18-.097-.18H7.989c-.072 0-.164.055-.223.139l-1.375 1.94c-.042.067-.088.07-.093.07h-.003a.066.066 0 0 1-.068-.07V9.06a.124.124 0 0 0-.127-.124zm11.252 0l-.026.027v.305l.026.028h.168c.068 0 .127.04.127.11l-.017.071-1.817 5.421v.01a.119.119 0 0 0 .017.093c.004.005.004.01.008.013a.127.127 0 0 0 .084.037h1.417c.068 0 .14-.056.169-.126l1.205-3.798s.017-.057.064-.057c.046 0 .058.057.058.057l1.223 3.798c.025.07.097.126.168.126h1.413a.11.11 0 0 0 .097-.052.14.14 0 0 0 .017-.09c0-.003-.005-.007-.005-.01l-1.968-5.88c-.03-.07-.097-.083-.169-.083zm-4.68 0l-.012.027v.305l.012.028h.194c.071 0 .127.055.127.126v5.503c0 .07.055.126.126.126h1.438a.125.125 0 0 0 .126-.126V9.06a.124.124 0 0 0-.126-.124zM22.592 12c0 2.902-4.751 5.264-10.594 5.264-5.843 0-10.594-2.362-10.594-5.264 0-2.901 4.751-5.263 10.594-5.263C17.84 6.737 22.592 9.1 22.592 12m-2.116-4.265c-2.268-1.132-5.278-1.757-8.478-1.757s-6.21.625-8.474 1.757C1.248 8.872 0 10.385 0 12c0 1.615 1.248 3.13 3.524 4.267 2.264 1.132 5.274 1.755 8.474 1.755s6.21-.623 8.478-1.755C22.748 15.129 24 13.615 24 12c0-1.615-1.252-3.128-3.524-4.265Z"
  }));
};

Kia.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Kia.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Kia;
exports.default = _default;